module.exports = __webpack_public_path__ + "c881a638288ec9bbb578f039cacbb650.jpg";